import { getPromo } from '../promos';

import Carousel from "react-multi-carousel";
import { PromoHeading } from './promoMidSection';

const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        }
    };

export const LandingHeader = (props) => {
    const promo = getPromo(props.sportKey);
    const headline = props.headline || "Real-time feedback and analysis";
    const subHeading = props.subHeading;
    const caption = props.caption;
    const images = props.images || [];
    return (<section className="atf-hero-area atf-shape " style={{background: 'url(./assets/img/bglines.jpg)', backgroundRepeat: 'no-repeat', backgroundPosition: "top left"}}>
                        <div className="non-landing-banner
                        "></div>
                            <div className="container">
                                <div className="row justify-content-center clearfix">
                                        <div className="d-none d-lg-block col-lg-8 col-0 text-center align-self-center atf-single-details pt-3">
                                            <h2 className="heading-size" style={{ fontFamily: "Bebas Neue", fontSize: "72px", marginTop: '30px', marginBottom: '0px', color:"var(--thm-black)"}}>{headline}</h2>
                                            <h4 className="heading-size" style={{ marginTop: '5px', marginBottom: '0px', color:"yellowgreen"}}>{subHeading}</h4>
                                            <p className="sub-heading-size" style={{ marginTop: '10px', color:"#666666" }}>{caption}</p>
                                            <div className="d-inline-block col-6 mt-5">
                                                <PromoHeading promo={promo} />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-12 text-center atf-single-details pb-3 pt-2">
                                        
                                         <h2 className="heading-size d-block d-lg-none" style={{ fontFamily: "Bebas Neue", padding: '10px 20px', fontSize: "56px", color:"yellowgreen", marginTop: '5px', marginBottom: '0px', background: '#404040' }}>{headline}</h2>
                                        { subHeading && <h4 className="heading-size d-inline-block d-lg-none" style={{ marginTop: '0px', fontSize: '24px', margin: '-5px 0px', padding: '3px 30px', color:"yellowgreen", background: 'white', border: '1px solid #DDD', filter: 'drop-shadow(5px 5px 4px #999)'}}>{subHeading}</h4>
}

                                        <img className="col-7 col-lg-8" src={images[0].src} style={{marginTop: '30px'}}/> 

                                       
                                        <p className="sub-heading-size d-block d-lg-none" style={{ color:"#666666", paddingTop: '15px', marginBottom: '0px' }}>{caption}</p>
                                            

                                        {1==2 &&<Carousel
                                            swipeable={true}
                                            draggable={true}
                                            showDots={true}
                                            responsive={responsive}
                                            infinite={true}
                                            autoPlay={true}
                                            autoPlaySpeed={2500}
                                            keyBoardControl={true}
                                            customTransition="transform 300ms ease-in-out"
                                            transitionDuration={500}
                                            containerClass="carousel-container"
                                            dotListClass="custom-dot-list-style"
                                            itemClass="carousel-item-padding-40-px"
                                        >
                                            {images.map((image, index) => <div className="px-1" key={index}>
                                                <div className="hero-caption" style={{top: image.captionTop}}>
                                                    <div style={{ margin: '0px 0px 0px 0px', color:"white", fontFamily: 'Comfortaa' }}>{image.caption}</div>
                                                </div>
                                                <img className="hero-carousel-img" style={image.imgStyle} src={image.src} alt={image.alt} />
                                            </div>)}
                                        </Carousel>}
                                        </div>
                                    </div>
                                    <div className="d-block d-lg-none row justify-content-center clearfix mt-4">
                                        <div className="text-center align-self-center p-2">
                                            <PromoHeading promo={promo} />
                                        </div>
                                </div>
                            </div>
                        </section>
    
    );
}

export default LandingHeader;